import NotImplementedError from '@/helpers/errors/NotImplementedError';
import { SxsDisplayTypes } from '../constants';
import stackedTimeseries from './stackedTimeseries';
import timeseries from './timeseries';

const formatter = 'sxsDuration';

function getOverrides(kpi) {
  const overrides = {
    yaxis: { start: 'auto', end: 'auto' },
  };
  const isPercent = kpi.isPercentOperation();
  const metric = isPercent
    ? 'percent of time matching'
    : kpi.getMetricPropertyName(kpi.measurements[0]);
  const asPercent = kpi.getSxsDisplayType() === SxsDisplayTypes.DELTA_PERCENT;
  if (asPercent) {
    overrides.yaxis.title = `Percent difference between ${metric}`;
  } else {
    overrides.yaxis.title = `Difference between ${metric}`;
  }
  return overrides;
}

function formatSxsDurationAsDelta(kpi, resultData) {
  const stacked = timeseries(kpi, resultData);
  stacked.formatter = formatter;
  stacked.overrides = getOverrides(kpi);
  return stacked;
}

function formatSxsDurationAsGroup(kpi, resultData) {
  const stacked = stackedTimeseries(kpi, resultData);
  stacked.formatter = formatter;
  return stacked;
}

export default function formatSxsDuration(kpi, resultData) {
  const isDelta = kpi.getSxsDisplayType().startsWith('delta');
  const isGroup = !isDelta;

  if (isDelta) {
    return formatSxsDurationAsDelta(kpi, resultData);
  }
  if (isGroup) {
    return formatSxsDurationAsGroup(kpi, resultData);
  }

  throw new NotImplementedError('SxS when not group or delta');
}
